import * as React from "react";
import { useState } from "react";
import { sendPostRequest } from "../../Client/index.js";
import loginBackground from "../../Assets/Images/login-background.png";
import logo from "../../Assets/Images/ballerz-logo-white.png";
import welcome from "../../Assets/Images/welcome.png";
import ballerz from "../../Assets/Images/ballerz.png";
import login from "../../Assets/Images/login.png";
import loginMobile from "../../Assets/Images/login-mobile.png";

function Login() {
  const [submitted, setSubmitted] = useState(false);

  const [successMessage, setSuccessMessage] = useState({});
  const [errorMessage, setErrorMessage] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await sendPostRequest("user-auth/login", {
      email: e.target.email.value,
    });

    if (res.success === "email_sent") {
      setSubmitted(true);
      setSuccessMessage({
        title: "Success!",
        message: "Please check your email - we have sent you a link to login",
      });
      setErrorMessage({});
    } else {
      setSuccessMessage({});
      setErrorMessage({
        title: "Oops",
        message: "Please enter a valid email address",
      });
    }
  };

  return (
    <div
      className="relative flex items-center justify-center px-8 py-16 bg-cover bg-center text-white w-screen h-screen"
      style={{
        backgroundImage: `url(${loginBackground})`,
      }}
    >
      <img
        src={logo}
        alt="Top Left"
        className="absolute top-10 left-1/2 sm:top-20 sm:left-20 transform -translate-x-1/2 sm:translate-x-10 w-40 h-auto"
      />
      <div className="flex flex-col gap-1 items-center justify-center">
        <img
          src={login}
          alt="Login"
          className="w-[70%] sm:w-[55%] h-auto mt-10 hidden sm:block"
        />
        <img
          src={loginMobile}
          alt="loginMobile"
          className="w-[75%] h-auto block sm:hidden mb-20"
        />

        {!submitted && (
          <>
            <form onSubmit={handleSubmit}>
              <div className="mt-0 text-sm font-semibold py-3 tracking-wide Kallisto_Bold w-[90%] text-center">
                ENTER YOUR BOOKING EMAIL ADDRESS BELOW:
              </div>

              <div className="flex flex-col items-center gap-4 max-w-md mx-auto w-[90%] mt-6">
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="EMAIL ADDRESS"
                  className="w-full px-10 py-4 border-2 border-white text-white bg-transparent uppercase tracking-wide font-semibold placeholder-white focus:outline-none Kallisto_Bold"
                />

                <button className="w-full bg-[#4F55F6] text-white py-4 font-bold uppercase tracking-wide hover:bg-[#3a45c8] transition-colors duration-300 Kallisto_Bold">
                  Let’s go!
                </button>
              </div>
            </form>
          </>
        )}

        {submitted && successMessage.title && (
          <div
            className="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md mt-10"
            role="alert"
          >
            <div className="flex">
              <div className="py-1">
                <svg
                  className="fill-current h-6 w-6 text-teal-500 mr-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                </svg>
              </div>
              <div>
                <p className="font-bold">{successMessage.title}</p>
                <p className="text-sm">{successMessage.message}</p>
              </div>
            </div>
          </div>
        )}

        {errorMessage.title && (
          <div role="alert" className="mb-4 mt-10">
            <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2">
              {errorMessage.title}
            </div>
            <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
              <p>{errorMessage.message}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
